enum TelemetryEvents {
    WATCH_DEMO_BUTTON = "Watch Demo Button Clicked",
    GET_STARTED_BUTTON_HOME = "Get Started Button Clicked (HOME)",
    GET_STARTED_BUTTON_MENU = "Get Started Button Clicked (MENU)",
    GET_STARTED_BUTTON_MENU_MOBILE = "Get Started Button Clicked (MENU MOBILE)",
    START_YOUR_FIRST_INTERVIEW_BUTTON_MENU_MOBILE = "Start Your First Interview Button Clicked",
    SIGN_IN_BUTTON = "Sign In Button Clicked",
    SIGN_UP_BUTTON = "Sign Up Button Clicked",
    GOOLGLE_SIGNIN_POPUP = "Google SignIn Popup",
    GOOLGLE_MANUAL_SIGNIN_BUTTON = "Google Manula SignIn Button Clicked",
    GOOLGLE_MANUAL_SIGNIN_POPUP = "Google Manula SignIn Popup",
    FORGET_PASSWORD_BUTTON = "Forget Password Buttton CLicked",
  }

  export { TelemetryEvents };